webpackJsonp([63],{

/***/ 1226:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".footer-info-link:hover{-webkit-transition:all .15s;transition:all .15s}.footer-info-sns{margin:0 .3em}.footer-info-sns:hover{-webkit-animation:pop .45s;animation:pop .45s}.footer-info-sns .fa{padding:0 .3em}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/footer/FooterCompany1/src/components/footer/FooterCompany1/FooterCompany1.l.scss"],"names":[],"mappings":"AAII,wBAEI,4BAA6B,AAC7B,mBAAqB,CACtB,AAEH,iBACE,aAAc,CAQf,AATD,uBAGI,2BAA4B,AACpB,kBAAoB,CAC7B,AALH,qBAOI,cAAe,CAChB","file":"FooterCompany1.l.scss","sourcesContent":["@import '~scss/variables';\n\n.footer {\n  &-info {\n    &-link {\n      &:hover {\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n      }\n    }\n    &-sns {\n      margin: 0 .3em;\n      &:hover {\n        -webkit-animation: pop 450ms;\n                animation: pop 450ms;\n      }\n      & .fa {\n        padding: 0 .3em;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("32044d10", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/63.22402db1591efb06d0f7.js